import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import { Box, Flex } from "@100mslive/roomkit-react";
import { Cross } from "../../icons";
import FullPageProgress from "../FullPageProgress";
import { ToastManager } from "../Toast/ToastManager";
import { SESSION_AUTH } from "../../common/auth";
import { ACCOUNT_SERVICES, USER_SERVICES } from "../../services";

const LaningCommunityPopup = props => {
  const { onClose } = props;
  const { isUserSession, LOGOUT_USER_SESSION, UPDATE_USER_SESSION } =
    SESSION_AUTH();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!isUserSession) {
      onClose();
    }
    return () => null;
  }, [isUserSession, onClose]);

  const createUserOrgAccount = () => {
    try {
      setLoading(true);
      ACCOUNT_SERVICES.create({
        userId: isUserSession?.userId,
        org: isUserSession?.org?.id,
      })
        .then(data => {
          if (data.code === 200) {
            switchUserAccount(data.data);
            return;
          } else if (data.code === 600) {
            LOGOUT_USER_SESSION();
            onClose();
          } else {
            ToastManager.addToast({ title: data.message });
          }
          setLoading(false);
        })
        .catch(err => {
          ToastManager.addToast({ title: err.message });
          setLoading(false);
        });
    } catch (err) {
      ToastManager.addToast({ title: err.message });
    }
  };

  const switchUserAccount = item => {
    if (item?.accountId === isUserSession?.org?.id) return;
    setLoading(true);
    USER_SERVICES.switchAccount({
      userId: isUserSession?.userId,
      org: isUserSession?.org?.id,
      switch: item?.accountId,
    })
      .then(data => {
        if (data.code === 200) {
          UPDATE_USER_SESSION({ org: data?.data });
          navigate("/account/setting");
        } else if (data.code === 600) {
          LOGOUT_USER_SESSION();
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(error => {
        ToastManager.addToast({ title: error.message });
      })
      .finally(() => {
        onClose();
        setLoading(false);
      });
  };

  return (
    <Flex
      align="center"
      direction="column"
      className="eventsPopup eventsPopup-sm2 "
    >
      {loading && <FullPageProgress fixed={true} />}

      <Box className="eventsPopup-inner">
        <div className="eventsPopup-header">
          <div className="eventsPopup-header-desc text-primary fw-700 text-left">
            CREATE YOUR INVESTOR COMMUNITY HUB
          </div>
          <div className="eventsPopup-header-heading text-left ">
            Build a powerful investor community that drives engagement
          </div>

          <div className="eventsPopup-header-desc text-left text-light">
            Join the leading platform where public companies, investors, and
            experts connect through meaningful engagement.
          </div>
        </div>

        <div className="eventsPopup-close" onClick={onClose}>
          <Cross />
        </div>

        <div className="eventsPopup-content">
          <div className="events-page-landing-community-steps">
            <div className="events-page-landing-community-steps-list">
              <span className="fw-700 text-primary">Launch:</span> Create your
              branded investor hub with your logo, discussion boards, and
              investor analytics.
            </div>
            <div className="events-page-landing-community-steps-list">
              <span className="fw-700 text-primary">Engage:</span> Connect with
              investors through live events, Q&As, updates, and structured
              discussions.
            </div>

            <div className="events-page-landing-community-steps-list">
              <span className="fw-700 text-primary">Grow:</span> Expand your
              network as members discover your community within the 6ix
              ecosystem.
            </div>
          </div>
        </div>
        <div className="eventsPopup-footer">
          <Button
            color="primary"
            variant="outlined"
            className="events6ix-btn events6ix-btn-primary"
            type="button"
            disabled={loading}
            onClick={createUserOrgAccount}
          >
            Create my community
          </Button>
        </div>
      </Box>
    </Flex>
  );
};

export default LaningCommunityPopup;
